<template>
  <div class="full-screen" style="z-index: 10;background:#f5f5f5;">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">找回账号</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <div class="reaccount-box">
        <div class="reaccount-box__desc">如果通过此方式未能自主找回您的充值账号，可联系在线客服（11:00~21:00）帮忙找回！</div>
        <div class="reaccount-box__tip">请选择充值扣款日期（支付宝/微信的扣款日期）</div>
       <Calendar @choseDay="choseDay"></Calendar>
      <button type="button" @click="findAccount"  class="btn">找回账号</button>
      </div>
    </section>
    <!-- <div class="login">
      <h2>
        <img src="../../../assets/img/logo.png" />
      </h2>
      <ul>
        <li>
          <label>手机号码</label>
          <div>
            <input class="inp" type="text" placeholder="请输入登录手机号" />
          </div>
        </li>
        <li>
          <label>密码</label>
          <div>
            <input  class="inp" type="password" placeholder="请输入密码" />
          </div>
        </li>
      </ul>

      <div v-if="errorMsg.show" class="text-red">{{errorMsg.msg}}</div>
      <div class="btnbox">
        <button type="button" class="btn" >登录</button>
      </div>
    </div> -->

    <div id="confirm-modal" v-if="showModal" class="fixed-confirm" style="display: block;">
      <div class="fixed-c">
        <h3>登录成功</h3>
        <button class="btn" type="button" @click="hideModal">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '../../../services/userService'
import Calendar from 'vue-calendar-component'
import { Notify, Dialog } from 'vant'
export default {
  name: 'login',
  data () {
    return {
      chargeTime: '',
      showModal: false,
      userInfo: {}
    }
  },
  components: { Calendar },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    choseDay (data) {
      this.chargeTime = data
    },
    validate () {
      if (this.account === '') {
        this.errorMsg = { show: true, msg: '请输入手机号' }
      } else if (this.password === '') {
        this.errorMsg = { show: true, msg: '请输入密码' }
      } else {
        this.login()
      }
    },
    findAccount () {
      const chargeTime = this.chargeTime
      if (!chargeTime) return Notify('请选择充值扣款日期')
      userService.findAccount(`chargeTime=${chargeTime}`).then(res => {
        if (res.result) {
          const resData = res.data
          this.showModal = true
          const html = `<div class="reaccount-alert">账号： ${resData.account}<br>密码： ${resData.password} <p class="red">请务必截图保存账户密码</p></div>`
          Dialog({ message: html, confirmButtonText: '我知道了', confirmButtonColor: '#ff5d50' })
        } else {
          Dialog({ title: '提示', message: res.msg, confirmButtonColor: '#ff5d50' })
        }
      }).catch((err) => {
        Dialog({ title: '提示', message: err.msg, confirmButtonColor: '#ff5d50' })
      })
    },
    hideModal () {
      const obj = document.getElementById('confirm-modal')
      obj.style.opacity = 1
      this.slideOut(obj)
    },
    slideOut (obj) {
      obj.style.opacity -= 0.05
      if (obj.style.opacity > 0) {
        setTimeout(() => {
          this.slideOut(obj)
        }, 15)
      } else {
        this.showModal = false
      }
    }
  },
  mounted () {
    this.$router.isBack = true
  }
}
</script>

<style lang="less">
.reaccount-box{
  margin: 30px;
  background: #fff;
  border-radius: 10px;
  padding: 20px 20px 30px;
  &__desc{
    font-size: 19px;
    font-weight: bold;
    color: #000;
  }
  &__tip{
    font-size: 14px;
    padding: 10px 0;
  }
  .btn{
    font-size: 1.3rem;
    font-weight: 800;
    color: #fff;
    height: 2.6rem;
    background-color: #ff5d50;
    border-radius: 10px;
    text-align: center;
    margin-top: 20px;
    width: 100%;
    border: 0;
  }
}
.reaccount-alert{
  // text-align: left;
  line-height: 1.6;
  font-size: 16px;
  font-weight: 800;
  padding: 20px 0;;
  .red{
    padding-top: 5px;
    color: red;
  }
}
</style>
